<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "DrzavaBase"
};
</script>

<style scoped>

</style>